import { api, getBlob } from "../../services/NetworkBase";
import { saveAs } from "file-saver";

export async function GetBottleOrderSchedules(accountNumber) {
  try {
    let response = await api
      .get(`vlp/bottle-orders/account-number/${accountNumber}/schedules`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetBottleCountReport(startDate, endDate, statuses) {
  try {
    const statusParam = (statuses || []).join(",");
    let response = await api
      .get(`vlp/bottle-orders/reports/bottle-count?startDate=${startDate}&endDate=${endDate}&statuses=${encodeURIComponent(statusParam)}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetBottleOrders(startDate, endDate, orderStatus, searchText, page, dateFilter, pageSize) {
  try {
    let response = await api
      .get(`vlp/bottle-orders?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&page=${page}&orderStatus=${orderStatus}&dateFilter=${dateFilter}&pageSize=${pageSize}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetBottleOrder(orderNumber) {
  try {
    let response = await api
      .get(`vlp/bottle-orders/${orderNumber}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteBottleOrder(orderNumber) {
  try {
    let response = await api
      .delete(`vlp/bottle-orders/${orderNumber}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteOrderedBottle(id) {
  try {
    let response = await api
      .delete(`vlp/bottle-orders/ordered-bottles/${id}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateBottleOrder(order) {
  try {
    let response = await api.put(
      "vlp/bottle-orders",
      { json: order }
    );
    return response;
  } catch (error) {
    throw error;
  }
}


export async function AssignAccountBottleOrder(orderNumber, accountNumber) {
  try {
    let response = await api.put(
      `vlp/bottle-orders/${orderNumber}/account-number/${accountNumber}`
    ).json();
    return response;
  } catch (error) {
    throw error;
  }
}

 

export async function SaveBottleOrder(order) {
  try {
    let response = await api.post(
      "vlp/bottle-orders",
      { json: order }
    ).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateOrderedBottle(order) {
  try {
    let response = await api.put(
      "vlp/bottle-orders/ordered-bottles",
      { json: order }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

//AssignLabOrderToOrderedBottle(int labOrderNumber, int bottleOrderNumber, int recordId)
export async function AssignLabOrderToOrderedBottle(labOrderNumber,  bottleOrderNumber,  recordId) {
  try {
    let response = await api.put(
      "vlp/bottle-orders/" +bottleOrderNumber +"/ordered-bottles/" + recordId + "/lab-order/" + labOrderNumber
     
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveOrderedBottle(order) {
  try {
    let response = await api.post(
      "vlp/bottle-orders/ordered-bottles",
      { json: order }
    ).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function CreateLabOrderForBottleOrder(orderNumber,labOrderCount) {
  try {
    const orderId = parseInt(orderNumber, 10);
    let response = await api
      .post(`vlp/lab-orders/bottle-order/${orderId}/lab-order-count/${labOrderCount}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetOrdersByAccountNumber(refreshCount, accountNumber) {
  try {
    let response = await api
      .get(`vlp/bottle-orders/refresh-count/${refreshCount}/account-number/${accountNumber}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetOrdersByBottlerOrderNumber(orderNumber) {
  try {
    let response = await api
      .get(`vlp/lab-orders/bottle-order/${orderNumber}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

// 🧾 Chain of Custody Document
export async function GetChainOfCustodyDoc(bottleOrderNumber) {
  try {
    const blob = await getBlob(`vlp/bottle-orders/chain-of-custody/${bottleOrderNumber}`);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    saveAs(blob, `ChainOfCustody_${bottleOrderNumber}.pdf`);
  } catch (error) {
    console.error("Error downloading Chain of Custody document:", error);
  }
}

// 📦 Bottle Order Packing Slip
export async function GetPackingSlipDoc(bottleOrderNumber) {
  try {
    const blob = await getBlob(`vlp/bottle-orders/packing-slip/${bottleOrderNumber}`);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    saveAs(blob, `BottleOrderPackingSlip_${bottleOrderNumber}.pdf`);
  } catch (error) {
    console.error("Error downloading Bottle Order Packing Slip:", error);
  }
}

export async function GetOrderAttachments(orderNumber) {
  try {
    let response = await api
      .get(`vlp/bottle-orders/attachments/${orderNumber}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UploadOrderAttachment(formData) {
  try {
    let response = await api
      .post('vlp/bottle-orders/attachments/upload', {
        body: formData,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteOrderAttachment(orderNumber, id) {
  try {
    let response = await api
      .delete(`vlp/bottle-orders/${orderNumber}/attachments/${id}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

// ✏️ Batch update multiple bottle orders
export async function BatchUpdateBottleOrders(payload) {
  try {
    let response = await api
      .put("vlp/bottle-orders/batch-update", { json: payload })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

// 📋 Batch duplicate multiple bottle orders — single API call
export async function BatchDuplicateBottleOrders(payload) {
  try {
    let response = await api
      .post("vlp/bottle-orders/batch-duplicate", { json: payload })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

// ENB-588: copies a line; the copy is placed directly below the source
export async function DuplicateOrderedBottle(recordId) {
  try {
    let response = await api
      .post(`vlp/bottle-orders/ordered-bottles/${recordId}/duplicate`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

// ENB-588: saves line order; recordIds is the full list in display order
export async function ReorderOrderedBottles(orderNumber, recordIds) {
  try {
    let response = await api
      .put(`vlp/bottle-orders/${orderNumber}/ordered-bottles/sort-order`, {
        json: recordIds,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
